import React, { useState } from 'react';
import { Card } from 'antd';
import { Layout } from 'antd';
import HeaderComponent from './Layout/Header';
import MainForm from './MainForm';
import SubContentHeader from './Layout/SubContentHeader';
import { LoadingOutlined } from '@ant-design/icons';

const { Content } = Layout;

function Home() {
  const [loadingLinkPage, setLoadingLinkPage] = useState(false);

  return (
    <Layout 
      style={{ 
        height: '100vh',
        display: 'flex',
        flexDirection: 'column'
      }}>

      <HeaderComponent />

      <div
        style={{
          position: 'relative',
          width: '100%',
          flex: 1,
          // height: '100%',
          backgroundImage: `url(${process.env.PUBLIC_URL}/hospital.jpg)`,
          backgroundSize: 'cover',
        }}
      >
        <Content className='main_container'>
            <SubContentHeader />

            <Card
              style={{
                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.8)',
                backgroundColor: 'rgba(226, 228, 233, 0.8)', // Fondo semi-transparente
                backdropFilter: 'blur(5px)', // Difumina el fondo detrás
              }}
            >
              <MainForm setLoadingLinkPage={setLoadingLinkPage} />
            </Card>

        </Content>
      </div>
      <div style={{ 
        display: loadingLinkPage ? 'flex' : 'none', 
        justifyContent: 'center',
        alignItems: 'center', 
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.75)',
        zIndex: 9999 }}>
        <LoadingOutlined style={{ fontSize: 48, color: 'white' }} spin />
      </div>
      <div className='footer'>
          <div className='content'>
              <span>Copyright &copy; 2026</span>
              <span>35 Años en el corazón de Reynosa</span>
              <span><a href="aviso-privacidad">Aviso de Privacidad</a></span>
          </div>
      </div>
    </Layout>
  );
}

export default Home;